import React, { useContext } from 'react';
import { useNavigate } from 'react-router';
import { APP_ROUTES } from '../../constants/appRoutes';
import Block from '../../components/Block';
import styles from './styles.module.scss';
import { PhotoContext } from '../../context/PhotoProvider';

const MainPage = () => {
  const navigate = useNavigate();

  const { setStyleVariant } = useContext(PhotoContext);
  const navigateToMosaic = () => {
    navigate(APP_ROUTES.CHOOSE_SIZE_DIAMOND_PHOTO_MOSAIC);
  };
  const navigateToEmbroidery = () => {
    setStyleVariant(1);
    navigate(APP_ROUTES.CHOOSE_SIZE_EMBROIDERY);
  };

  const openYouTube = () => {
    window.open('https://youtube.com', '_blank');
  };

  return (
    <div className={styles.wrapper}>
      <Block
        text="Diamond Painting by Photo"
        description="Will offer several built options to choose from"
        variant="primary"
        main
        buttonAction={openYouTube}
      />
      <Block
        text="Diamond Painting Kit"
        color="pink"
        type="mosaic"
        size="medium"
        buttonAction={navigateToMosaic}
      />
      <Block
        text="Embroidery"
        color="blue"
        type="embroidery"
        size="medium"
        buttonAction={navigateToEmbroidery}
      />
    </div>
  );
};

export default MainPage;
